import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=ff900d1a&scoped=true&lang=html&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=ff900d1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff900d1a",
  null
  
)

export default component.exports